/**
 * The yellow-barred heading used at the top of a page or panel.
 *
 * Exists so a panel that overlays a page can line its title up with the page's
 * own — `AssetsListAssetPreview` sits directly over the assets grid, and any
 * drift in the bar, the font size or the left padding reads as the whole panel
 * being misaligned. The bar is `border-primary`, the theme yellow.
 *
 * Its own left offset is all this owns. Matching the *row* — the height and the
 * horizontal padding it sits in — is the caller's job, since that belongs to
 * the page's header layout rather than to the title.
 *
 * @input {children: 'Assets', size: 'page'}
 */
export default function PageTitle({
  children,
  id,
  // 'page' is the full-size heading a route renders; 'panel' is the smaller one
  // a modal or side panel uses.
  size = "page",
  className = "",
}) {
  const sizeClass = size === "panel" ? "text-xl" : "text-2xl";

  return (
    <h1
      id={id}
      className={`PageTitle font-bold border-l-4 border-primary pl-4 ${sizeClass} ${className}`}>
      {children}
    </h1>
  );
}
